/*
 * GALPÓN — Fade-in de imágenes LAZY al llegar (cards, secciones del home, thumbs).
 * ---------------------------------------------------------------------------
 * Problema: las fotos lazy "aparecen de golpe" (pop) cuando terminan de bajar —
 * el velo ciego de entrada NO cubre eso (dura ~850 ms; una foto lazy puede llegar
 * cuando quiera). Esto las revela con un fade corto sobre el placeholder tonal.
 *
 * ⚖️ CONTRATO DE SEGURIDAD (regla dura del theme, ver harness decisions 2026-07-09
 * "nada que oculte contenido puede depender de que un JS corra"):
 *   · El estado oculto (.gd-imgload) lo pone SOLO este JS. Si el JS no corre,
 *     ninguna imagen queda oculta jamás.
 *   · Una vez armada, la revelación NO depende del JS: la clase .gd-imgload trae
 *     una animación CSS failsafe (revela sola a los 2.5 s) por si el load nunca
 *     dispara o el JS muere después de armar.
 *   · Imágenes ya cargadas (cache) se saltan → aparecen instantáneas, sin fade.
 *   · Solo imágenes loading="lazy" dentro de <main>: la foto LCP (eager /
 *     fetchpriority=high) NO se toca — ocultarla dañaría el LCP y el velo ya la cubre.
 *
 * El reveal usa ANIMATION (no transition) a propósito: .product-card img define
 * `transition: transform !important` (hover zoom) que pisaría una transición de
 * opacity. La animación es propiedad aparte, no chocan.
 */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function arm(img) {
    if (img.complete && img.naturalWidth > 0) return; // ya está (cache) → instantánea
    img.classList.add('gd-imgload');
    var reveal = function () { img.classList.add('gd-imgload--in'); };
    img.addEventListener('load', reveal, { once: true });
    img.addEventListener('error', reveal, { once: true });
  }

  function scan() {
    // TODAS las imágenes de main, eager incluidas (jul 2026): en páginas dominadas por
    // foto (hero del home, foto de PDP) la "llegada de golpe" ES la imagen eager
    // apareciendo seca cuando decodifica — el velo de entrada no puede cubrirla sin
    // esperas prohibidas. El fade arranca EN el load de cada imagen → el costo LCP es
    // un frame (la imagen no existía visualmente antes de su load igual). El contrato
    // a prueba de fallos es el mismo: cacheada → instantánea; armada → failsafe CSS 2.5s.
    document.querySelectorAll('main img').forEach(arm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }
})();
